const DEFAULT_SWIPER_CONFIG = {
    direction: 'horizontal',
    slidesPerView: 'auto',
};
const ɵ0 = DEFAULT_SWIPER_CONFIG;
export class AppModule {
}
export { ɵ0 };
